import React from 'react';
import PropTypes from 'prop-types';

const CloseButton = ({ imageSrc, onClick, ariaLabel }) => (
  <button
    type="button"
    className="vto__modal-close-button"
    onClick={onClick}
    aria-label={ariaLabel || 'Close'}
  >
    <img src={imageSrc} alt="" />
  </button>
);

CloseButton.propTypes = {
  imageSrc: PropTypes.string,
  onClick: PropTypes.func,
  ariaLabel: PropTypes.string,
};

export default CloseButton;
